import { render, staticRenderFns } from "./DeleteReserve.vue?vue&type=template&id=0064f6de&scoped=true"
import script from "./DeleteReserve.vue?vue&type=script&lang=js"
export * from "./DeleteReserve.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0064f6de",
  null
  
)

export default component.exports